<div class="global-supplier-selector" *ngIf="globalSupplierService.isAvailable">
  <div class="global-supplier-apps">
    <img *ngIf="current?.selfnet" [src]="logoSN" class="global-supplier-app global-supplier-app-sn"
      matTooltip="Rete presente su Selfnet" matTooltipClass="fastlane-tooltip" />
    <img *ngIf="current?.overview" [src]="logoOV" class="global-supplier-app global-supplier-app-ov"
      matTooltip="Rete presente su Overview" matTooltipClass="fastlane-tooltip" />
  </div>
  <app-grid-select-box class="global-supplier-box" [dataSource]="rows" keyExpr="key" [displayExpr]="displayExpr"
    [columns]="columns" placeholder="Tutte le reti" [noDataText]="noDataText" [value]="selectedKey"
    [dropDownWidth]="680" (selectionChanged)="onSelectionChanged($event)">
  </app-grid-select-box>
</div>
